module.exports = {
  notIssued: 'ยังไม่ได้ออก',
  getBack: 'รับคืนแล้ว',
  receive: 'รับแล้ว',
  toClaim: 'รับรองแล้ว',
  issuance: 'ออกแล้ว',
  changeSingle: 'กำลังแก้ไขเอกสาร',
  lineCreditDialog: {
    title: 'ข้อความแจ้งเตือน',
    businessNumber: 'หมายเลขบริการนี้:',
    mblNo: 'หมายเลข MBL:',
    hblNo: 'หมายเลข HBL:',
    partners: 'พันธมิตร:',
    lines: 'วงเงินเครดิต: เกินแล้ว {0} บาท',
    paymentDays: 'ระยะเวลาการชำระเงินเครดิต: {0}',
    unableSave: 'ไม่สามารถใช้ "เอกสารที่ลูกค้าออกเอง" ได้ กรุณาชำระเงินทันเวลา',
    cantUse: 'ขณะนี้ไม่สามารถบันทึกตัวเลือกในฟิลด์เอกสารที่ลูกค้าออกเองได้',
    triggerRemind: 'ระบบได้แจ้งเตือนแล้ว กรุณาชำระเงินทันเวลา',
    through: 'กฎการปล่อยเอกสารผ่านการตรวจสอบแล้ว',
    continueOrders: 'ยืนยันที่จะปล่อยเอกสารต่อหรือไม่?',
    confirm: 'ยืนยัน',
    cancel: 'ปิด'
  }
}
